import { useEffect, useState } from 'react';
import { Keyboard, KeyboardEvent, Platform } from 'react-native';

/**
 * Extra bottom inset when the keyboard is visible — add to ScrollView `contentContainerStyle.paddingBottom`
 * on **Android** so auth modal forms stay scrollable.
 *
 * On **iOS**, prefer `ScrollView` `automaticallyAdjustKeyboardInsets` and **do not** add this value to
 * `paddingBottom` — doing both lifts the content twice (too much shift when the keyboard opens).
 */
export function useAuthSheetKeyboardInset(): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const show = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const hide = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';

    const onShow = (e: KeyboardEvent) => setHeight(e.endCoordinates.height);
    const onHide = () => setHeight(0);

    const subShow = Keyboard.addListener(show, onShow);
    const subHide = Keyboard.addListener(hide, onHide);
    return () => {
      subShow.remove();
      subHide.remove();
    };
  }, []);

  return height;
}
